import { render, staticRenderFns } from "./QuoteCards.vue?vue&type=template&id=1be65288&scoped=true&"
import script from "./QuoteCards.vue?vue&type=script&lang=js&"
export * from "./QuoteCards.vue?vue&type=script&lang=js&"
import style0 from "./QuoteCards.vue?vue&type=style&index=0&id=1be65288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be65288",
  null
  
)

export default component.exports